// src/App.js
import { useContext, useEffect, useState } from 'react';
import '../App.css';
import Ball from "../components/draganddrop/Ball"
import Bucket from "../components/draganddrop/Bucket"
import { HTML5Backend } from 'react-dnd-html5-backend';
import { TouchBackend } from 'react-dnd-touch-backend'
import { DndProvider } from 'react-dnd';
import LanguageContext from './hooks/LanguageContext';
import parse from 'html-react-parser';
import ModalInstruction from './ModalInstruction';
import { getText } from '../utils/languageUtils';


const QuizMultiSelectDragDrop = ({ question, isMarked, rightBucket, setRightBucket, wrongBucket, setWrongBucket }) => {
    const { language, translations: translationData } = useContext(LanguageContext);
    const translations = translationData;
    const [screenSize, setScreenSize] = useState(getCurrentDimension());

    const [balls, setBalls] = useState(question?.options)
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    function getCurrentDimension() {
        return {
            width: window.innerWidth,
            height: window.innerHeight
        }
    }

    useEffect(() => {
        const updateDimension = () => {
            setScreenSize(getCurrentDimension())
        }
        window.addEventListener('resize', updateDimension);


        return (() => {
            window.removeEventListener('resize', updateDimension);
        })
    }, [screenSize])

    const handleDrop = (id) => {
        let remainingBalls = balls.filter((ball) => ball.id == id);
        let droppedBall = balls.find((ball) => ball.id === id);

        if (droppedBall.isRight) {
            setRightBucket((prev) => [...prev, droppedBall]);
        } else {
            setWrongBucket((prev) => [...prev, droppedBall]);
        }

        switch (droppedBall.id) {
            case 1:
                const updatedBalls1 = [...balls];
                updatedBalls1[0].ballStatus = true;

                setBalls(updatedBalls1);
                break;
            case 2:
                const updatedBalls2 = [...balls];
                updatedBalls2[1].ballStatus = true;

                setBalls(updatedBalls2);
                break;
            case 3:
                const updatedBalls3 = [...balls];
                updatedBalls3[2].ballStatus = true;

                setBalls(updatedBalls3);
                break;
            case 4:
                const updatedBalls4 = [...balls];
                updatedBalls4[3].ballStatus = true;

                setBalls(updatedBalls4);
                break;
            case 5:
                const updatedBalls5 = [...balls];
                updatedBalls5[4].ballStatus = true;

                setBalls(updatedBalls5);
                break;
            case 6:
                const updatedBalls6 = [...balls];
                updatedBalls6[5].ballStatus = true;

                setBalls(updatedBalls6);
                break;
        }
    };


    useEffect(() => {
        if (isMarked === 1) {
            const { multi_select_dnd } = translations;

            setBalls([
                { id: 1, ballStatus: true, isRight: true, title: multi_select_dnd.ball_1 },
                { id: 2, ballStatus: true, isRight: false, title: multi_select_dnd.ball_2 },
                { id: 3, ballStatus: true, isRight: false, title: multi_select_dnd.ball_3 },
                { id: 4, ballStatus: true, isRight: true, title: multi_select_dnd.ball_4 },
                { id: 5, ballStatus: true, isRight: false, title: multi_select_dnd.ball_5 },
                { id: 6, ballStatus: true, isRight: true, title: multi_select_dnd.ball_6 },
            ]);

            setRightBucket([
                { id: 1, ballStatus: true, isRight: true, title: multi_select_dnd.ball_1 },
                { id: 2, ballStatus: true, isRight: false, title: multi_select_dnd.ball_2 },
                { id: 3, ballStatus: true, isRight: false, title: multi_select_dnd.ball_3 },
            ]);

            setWrongBucket([
                { id: 4, ballStatus: true, isRight: true, title: multi_select_dnd.ball_4 },
                { id: 5, ballStatus: true, isRight: false, title: multi_select_dnd.ball_5 },
                { id: 6, ballStatus: true, isRight: true, title: multi_select_dnd.ball_6 },
            ]);
        }
    }, [isMarked])


    return (
        <DndProvider backend={screenSize.width >= 921 ? HTML5Backend : TouchBackend}>
            <>
                <div className='justify-content-end d-flex' >
                    <div onClick={handleShow}>
                        <img src={require("../assets/images/instructions.png")} className='mobielViewIcon' />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="sectionsBox">
                            <p className="mb-0 text-center">{getText(question?.title, language)}</p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 ">
                        <div className="contentbox mb-2 mt-3">
                            <div className="content_safty ">
                                {parse(getText(question?.description, language))}
                            </div>
                        </div>
                    </div>
                </div>
                <section className="my-3">
                    <div className="container-fluid">
                        <div className='d-flex align-item-center justify-content-between'>
                            <div style={{}}>
                                {balls.map((ball) => {

                                    return (
                                        <Ball key={ball.id} id={ball.id} isRight={ball.isRight} ballStatus={ball.ballStatus} text={getText(ball.title, language)} />
                                    )
                                })}
                            </div>
                            <div className="d-flex align-items-center">
                                <div style={{ alignContent: "center" }}>
                                    <Bucket type="RIGHT_BALL" onDrop={handleDrop}>
                                        <div style={{ display: "contents" }} className='text-center' >
                                            {rightBucket.length === 3 ? <img src={require("../assets/images/DCP2-gif.gif")} width={70}
                                            /> : <img src={require("../assets/images/bowlcheck.png")} width={70} />}
                                            <p className='text-center'>{getText(translations?.multi_select_quiz?.strong, language)} </p>
                                        </div>
                                    </Bucket>
                                    <Bucket type="WRONG_BALL" onDrop={handleDrop}>
                                        <div style={{ display: "contents" }} className='text-center' >
                                            {wrongBucket.length === 3 ? <img
                                                src={require("../assets/images/DCP2-gif-2.gif")} width={70}
                                            />
                                                : <img src={require("../assets/images/bowlcheck.png")} width={70} />}
                                            <p className='text-center '>{getText(translations?.multi_select_quiz?.weak, language)}</p>
                                        </div>
                                    </Bucket>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>

                <ModalInstruction show={show} handleClose={handleClose} inst={parse(getText(question.instruction, language))} />
            </>
        </DndProvider>
    );
};

export default QuizMultiSelectDragDrop;
